import ExperimentContext from '@/context/ExperimentContext'
import pclnExperimentation from '@pcln/experimentation'
import { useContext, useEffect } from 'react'

export default function useSeti(experimentCode: string, shouldFireImpression = true) {
  const { [experimentCode]: setiTest = 'DEFAULT' } = useContext(ExperimentContext)

  useEffect(() => {
    if (experimentCode && shouldFireImpression) {
      pclnExperimentation.fireImpression(experimentCode)
    }
  }, [experimentCode, shouldFireImpression])

  return setiTest
}
